import { defineComponent as _defineComponent } from 'vue'
import {onMounted, ref} from "vue";
import {useRoute, useRouter} from "vue-router/composables";

import {OrderService} from "@/services/OrderService";
import {formatDate} from "@/services/globalFunctions";
import {ListedOrderResponseType} from "@/types/ListedOrderResponseType";


export default /*#__PURE__*/_defineComponent({
  __name: 'OrderList',
  setup(__props) {

const router = useRouter()
const route = useRoute()

const orderList = ref<ListedOrderResponseType>({})
const loading = ref<boolean>(false)
const message = ref<string>('')

onMounted(() => {
  const email:string = route.query.email as string
  const channel:string = route.query.channel as string
  loading.value = true
  OrderService.getOrderByEmail(email, channel)
      .then(value => {
        loading.value = false
        orderList.value = value.orders
        console.log(orderList.value)
      })
      .catch(reason => {
        loading.value = false
        if (reason['errors'] !== undefined) {
          router.push({
            name: 'search',
            query: {message: reason.errors}
          })
        } else {
          console.log(reason)
          message.value = reason
        }
      });
})

const showDetails = (number:string) => {
  router.push({
    name: 'order_detail',
    params: {id: number}
  })
}

return { __sfc: true,router, route, orderList, loading, message, showDetails, formatDate }
}

})